<p class="fw-bold fs-3 ms-3">{{ "faqs.faqs" | translate }}</p>

<div class="row p-4 content">
    <div class="col-md-4 col-12">
        <div class="category d-flex gap-3 justify-content-center" [class.active]="selectedCategoryId === undefined" (click)="filter()">
            <i class="icon fa-solid fa-star"></i>
            <p class="fw-bold my-2">{{ "common.form.label.all" | translate }}</p>
        </div>
        @for (item of categories(); track $index) {
            <div class="category d-flex gap-2 justify-content-center" [class.active]="item.id === selectedCategoryId" (click)="filter(item.id)">
                <p class="fw-bold my-2">{{ item | translateToken: "name" }}</p>
                <p class="my-2">({{ item.totalFaqs }})</p>
            </div>
        }
    </div>
    <div class="col-md-8 col-12 bg-card p-3">
        <div class="my-2 w-100">
            <input
                #searchInputEl
                type="search"
                class="form-control"
                autocomplete="on"
                inputmode="search"
                aria-label="'breadcrumbs.search' | translate"
                [placeholder]="'search.search_for_questions' | translate"
                (input)="performSearch($event)"
            />
        </div>
        @for (item of questions(); track $index) {
            <div ngbAccordion>
                <div ngbAccordionItem>
                    <h2 ngbAccordionHeader>
                        <button class="btn" ngbAccordionButton [attr.dir]="languageService.direction()">
                            <span
                                class="text-start"
                                [class.text-end]="languageService.direction() === 'rtl'"
                                style="flex-grow: 2"
                                [attr.dir]="languageService.direction()"
                            >
                                <p class="mb-1 fw-bold">{{ getLabel(item.categoryId) }}</p>
                                <p class="mb-0">{{ item | translateToken: "question" }}</p>
                            </span>
                        </button>
                    </h2>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                <p>{{ item | translateToken: "answer" }}</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>

@if (totalRows > limit) {
    <div class="d-flex align-items-center justify-content-end me-5 mt-5 adaa--pagination">
        <ngb-pagination [collectionSize]="totalRows" [(page)]="currentPage" [pageSize]="limit" [maxSize]="5" (click)="onPageChange($event)">
        </ngb-pagination>
    </div>
}
